<!-- EVENT -->
<div class="bg">
  <div class="wrapper">
    <div class="main-card" >
      <div class="cards" >
        <div class="card">
          <div class="content">
            
            <div class="cover-picture-box">
              <div class="cover-picture">
                <img src="http://localhost:9091/Event/{{ eventa.image }}" alt="Photo de Couverture" />
              </div>
            </div>
            
            <hr>
  
  <!--Detail participation-->
            <h3>Organized by {{ eventa.user.titre }}</h3>
            
  
            <div *ngIf="eventa.availablePlaces > 0; else noPlacesLeft">
              <p style="color: #2D2F44;">Want to participate? Click here! Only {{ eventa.availablePlaces }} place(s) left to register.</p>
            </div>
            <ng-template #noPlacesLeft>
              <h4 style="color: red;">No places left for this event.</h4>
            </ng-template>
               <!-- Participate Button -->
     <button *ngIf="!isParticipated" [hidden]="eventa.availablePlaces === 0" class="btn btn-secondary" (click)="addParticipant()">Participate</button>
  
     
     <!-- Cancel Participation Button -->
     <button *ngIf="isParticipated"  class="btn btn-secondary" style="background-color: #ff7a0c;" (click)="cancelParticipation()">Cancel Participation</button>
    
   
  
            <!--Two Cards -->
            <div class="row">
              <div class="col-sm-6">
                <div class="card" style=" width: 450px;">
                  <div class="card-body">
                    <h3 class="card-title" style="color:#2D2F44 ; font-weight: bold;">{{eventa.titre}}</h3>
                    <br>
                    <!--About the event</h5>-->
                    <div>
                    
                    <p><img src="../../../assets/images/Group 380.png" height="30px" width="30px" style="margin-right: 10px;">+{{this.participationCount}} are enrolled to this event</p>
                  </div>
                  
                      <a style="color: #5a54ff;" *ngIf="eventa.type === 'virtual'" [href]="eventa.meetingLink" target="_blank">Meeting Link {{eventa.zoomlink}}</a>
                    
                    <h5 class="duration">Duration: </h5>
                    <p><img src="../../../assets/images/Group 388.png" height="30px" width="30px" style="margin-right: 10px;"><br> Start: {{eventa.startime}}<br>
                    End: {{eventa.endtime}}</p>
                    <p><img src="../../../assets/images/Group 389.png" height="30px" width="30px" style="margin-right: 10px;">Public-tout le monde</p>
                    <h5>Description:</h5> 
                    <p>{{eventa.description}}</p>
                  
                  </div>
                </div>
              </div>
              <div class="col-sm-6" >
                <div class="card" style="width: 550px;">
                  <div class="card-body">
                    <h5 class="card-title text-middle">Pay a visit to the location</h5>
                    <!--show google map  -->
                    <iframe width="500" height="400" frameborder="0" style="border:0" [src]="mapUrl" allowfullscreen></iframe>
  
                  
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                    <a href="{{eventa.location}}" class="btn btn-secondary" target="_blank">Check Google Maps</a>
                  </div>
                </div>
              </div>
            </div>
            
            
            
  
             <!--Left  Card-->
        
     
          <!--  <div class="img">
              <img src="http://localhost:9091/Event/{{ eventa.image }}" alt="Event Picture" style="max-width: 100%; max-height: 700px;"/>
            </div>
            <div class="detailplace">
              <img src="../../../assets/images/Group.png"><h2>Event will be started on : {{eventa.date}}</h2>
            <p >Place name : {{eventa.location}}</p>
          </div>
           <h4>{{eventa.titre}}</h4>
            <br>
            <p style="margin-left: 10%; margin-right: 10%; text-align: center; color: black; font-size: medium; font-family: Arial, Helvetica, sans-serif; text-indent: 5px;">{{eventa.description}}</p>
            <br>
    
            <a style="margin-left: 80%; color: #5a54ff; font-size: x-large; margin-bottom: -28px;"  href="/home/events/event" (click)="likeEvent()">
              <fa-icon [icon]="faComment"  class="material-icons"></fa-icon>
            </a>-->
            <!-- ...location condition... -->
  <!--
            <h4 style="margin-left:60% ;color: black;" *ngIf="eventa.type === 'physical'">Place name: {{eventa.location}}</h4>
            <a style="margin-left: 88%; color: #5a54ff;" *ngIf="eventa.type === 'virtual'" [href]="eventa.meetingLink" target="_blank">Meeting Link</a>
            <div class="col-5" *ngIf="eventa.type === 'physical'">
              <iframe width="520" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="{{eventa.location}}&&output=embed"></iframe> <a href='https://embed-map.org/'>google maps for my website</a> <script type='text/javascript' src='https://embedmaps.com/google-maps-authorization/script.js?id=2c5de4f0372874d6ff1be14ea14796eaccf61f58'></script>
              <h2>{{eventa.location}}</h2>
              
            </div>
            <p style="margin-left: 88%; color: #5a54ff;"> {{nComment}} Comments </p>
    
          -->
    
          <!-- <a style="color: #5a54ff; margin-top: -45px; margin-bottom: 17px; margin-left: -92%; font-size: x-large;" [ngClass] = "{'is-active' : hamClick}"  href="/home/events/event" (click)="likeEvent()">
              <fa-icon style="color: #5a54ff;" [icon]="faThumbsUp"  class="material-icons"></fa-icon>
            </a>
            
            <a class="dislike" style="color: #5a54ff; margin-top: -45px; margin-left: -88%;font-size: x-large;" (click)="dislikeEvent()"  href="/home/events/event">
              <fa-icon style="color: #5a54ff;" [icon]="faThumbsDown"  class="material-icons"></fa-icon>
            </a>
            -->
           <!--<i onclick="likeEvent()" #like class="fa fa-thumbs-up"></i> 
    
            <div style="margin-top: -8px; margin-left: -72%;">
              <h3>Category : {{eventa.category}}</h3>
            <p style="color: black; ">{{eventa.like}} Likes</p>
          </div>
            <br>
            <br>
            Add Comment-->
           
         
  
  
  
      
            <div class="form-group" *ngIf="comment" [hidden]="hideCommentform">
              <input style="width: 90%; height: 40px; margin-left: 0px;" type="text" class="form-control" placeholder="Comment" [(ngModel)]="comment.description" required #description="ngModel"/>
              <a href="/home/events/event">
                <button   routerLink="/home/events/event" class="btn btn-primary" style="height: 40px; margin-left: -20%;" (click)="addComment(comment)" [disabled]="description.invalid"> Add Comment </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!--Comments-->
    <!-- <div class="container2"> -->
    <div class="main-card"  *ngFor="let com of commentaire">
      <div class="cards">
        <div class="card">
          <div class="content">
            <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;">
              <img class="comPic" src="http://localhost:9091/User/{{ com.user.profileImage }}" style="width: 60px; height: 60px; border-radius: 50%; border: 2px solid #5a54ff; display: inline;" alt="profile Image"/>
              <a class="nav-link" style="font-weight: bold; display: inline; color: black; margin-left: 0px; margin-bottom: 10px;">
                <i class="ion-md-power"></i> &nbsp; {{com.user.nom}} {{com.user.prenom}} <br><small class="pub" style="margin-left: 125px;display: block;transform: translateY(-26px);">Published on : {{com.date}}</small>
              </a>
              <br>
            </li>
              <p style="margin-left: 8%; margin-right:8% ; margin-top: 10px; color: black; text-align: justify;" >{{com.description}}</p>
              <br>
              <!--<p style="margin-left: -100px; color: #5a54ff;" (click)="getReponseByCommentaireId(com._id)">Show Respons</p>-->
          </div>
          <a href="/home/events/event" (click)="deleteCommentaire(com._id)" [hidden]="hideSupp(com.user._id)"><fa-icon [icon]="faTrash"  class="material-icons" style="display: flex;float: right; transform: translateY(-900%);margin-right: 30px;"></fa-icon></a>
    
        </div>
      </div>
    </div>
    </div>
  </div>
   